import chatReducer from 'live/redux/reducers/chatReducer';
import gamesReducer from 'live/redux/reducers/gamesReducer';
import selectedGameReducer from 'live/redux/reducers/selectedGameReducer';
import topReducer from 'live/redux/reducers/topReducer';
import uiReducer from 'live/redux/reducers/uiReducer';
import { combineReducers } from 'redux';

const liveReducer = combineReducers({
  selectedGame: selectedGameReducer,
  chat: chatReducer,
  games: gamesReducer,
  top: topReducer,
  ui: uiReducer,
});

export default liveReducer;
